module.exports = __webpack_public_path__ + "img/pexels-photo-3944406.5513d5c8.jpeg";